import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormFields,
    FormActions,
    ValidationResult,
    CodedProperty,
    mapToDropdownOption,
    FormMultiselectDropdown
} from "sprint-common-web";

import { LanguagesDataContext } from "../../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { ensureVideoFileRecordDetails } from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";

export interface EditVideoSoundtrackFormProps {
    isLoading: boolean;
    onCancel?(): void;
    validationResult?: ValidationResult;
    onSubmit(soundtracks: CodedProperty[]): void;
}

interface EditVideoSoundtrackFormInputs {
    soundtracks: string[];
}

export const EditVideoSoundtrackForm = (props: EditVideoSoundtrackFormProps): JSX.Element => {
    const { fileRecordDetails } = useFileRecordDetailsState();
    const { dubbingLanguages } = useContext(LanguagesDataContext);

    ensureVideoFileRecordDetails(fileRecordDetails);

    const defaultSoundtracks = fileRecordDetails.soundtracks?.map((soundtrack) => soundtrack.id) ?? [];
    const { handleSubmit, errors, control } = useForm<EditVideoSoundtrackFormInputs>({
        defaultValues: {
            soundtracks: defaultSoundtracks
        }
    });

    const closeClearedAndCallOnClose = () => {
        if (props.onCancel) {
            props.onCancel();
        }
    };

    const callOnSubmit = (formInputs: EditVideoSoundtrackFormInputs) => {
        const soundtracksToSubmit = dubbingLanguages.filter((dubbingLanguage) =>
            formInputs.soundtracks.includes(dubbingLanguage.id)
        );

        props.onSubmit(soundtracksToSubmit);
    };

    return (
        <Form onSubmit={handleSubmit(callOnSubmit)}>
            <FormFields>
                <FormMultiselectDropdown
                    options={dubbingLanguages.map((dub) => mapToDropdownOption(dub))}
                    label="Soundtracks"
                    name="soundtracks"
                    control={control}
                    errors={errors}
                />
                <FormActions onCancel={closeClearedAndCallOnClose} isLoading={props.isLoading} />
            </FormFields>
        </Form>
    );
};
